// @ts-nocheck
import {ArrowsClockwise, Wallet as WalletIcon} from "@phosphor-icons/react";
import {useEffect, useState} from "react";
import {BaseTypography} from "@/components";
import CurrencyDropdown from "../../../components/CurrencyDropdown";
import UserAvatar from "../../../components/NavBar/Avatar/index";
import NotificationMenu from "../../../components/notification";
import useGetUserWallet from "../../../hooks/wallet/useGetUserWallet";
import {useBalanceStore} from "../../../store/useBalance.store";
import useCurrencyStore from "../../../store/useCurrency.store";

const balanceDisplayCls =
  "w-[7.8rem] h-10 flex items-center justify-center rounded-tr-md rounded-br-md max-[1200px]:rounded-md max-[1200px]:mr-2.5 max-[1200px]:min-w-[var(--size-25)] max-[1200px]:w-auto max-[1200px]:flex-1 max-[1200px]:text-xs max-md:mr-[var(--space-1-5)] max-md:text-[var(--font-caption)] max-md:min-w-[var(--size-22-5)] max-[480px]:min-w-[var(--size-20)] max-[480px]:text-[var(--font-eyebrow)]";
const balanceTextCls = "font-[var(--font-family)] text-[var(--white)] font-semibold text-sm ml-[50px]";
const iconRefreshCls =
  "mx-[var(--space-1-5)] my-0 transition-all duration-300 hover:cursor-pointer hover:text-[var(--color-primary)] hover:scale-[1.2] max-md:mx-[3px]";
const iconRefreshSpinCls = "animate-spin-once";
const walletIconCls =
  "bg-transparent p-[var(--space-1-5)] w-9 h-9 outline-none border-0 transition-all duration-300 hover:scale-[1.2] active:border-transparent! active:outline-none! active:shadow-none! focus:border-transparent! focus:outline-none! focus:shadow-none!";

const Wallet = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isSpinning, setIsSpinning] = useState(false);
  const widthResponsive = 1200;

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const {isLoading, balance, getAccountByCurrency, refetch} = useGetUserWallet();
  const selectedCurrency = useCurrencyStore(state => state.selectedCurrency);

  const handleBankAccountModal = useBalanceStore(state => state.handleBankAccountModal);

  const handleRefreshClick = () => {
    setIsSpinning(true);
    refetch();
    setTimeout(() => setIsSpinning(false), 700);
  };

  const selectedAccount = selectedCurrency ? getAccountByCurrency(selectedCurrency.id) : balance;

  const formatDisplayBalance = () => {
    const accountToDisplay = selectedAccount || balance;

    if (accountToDisplay) {
      return accountToDisplay.formattedBalance || "Bs. 0,00";
    }

    if (isLoading) {
      return "Bs. 0,00";
    }

    return "Bs. 0,00";
  };

  return (
    <div style={{display: "flex", alignItems: "center", marginRight: "30px"}}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: "2.5rem",
          width: windowWidth < widthResponsive ? "100%" : "auto",
        }}
      >
        <div
          className={balanceDisplayCls}
          style={{
            width: windowWidth < widthResponsive ? "auto" : "7.80rem",
            minWidth: windowWidth < widthResponsive ? "100px" : "10rem",
            flex: windowWidth < widthResponsive ? "1" : "none",
          }}
        >
          <BaseTypography.Text className={balanceTextCls}>{formatDisplayBalance()}</BaseTypography.Text>
        </div>
        <CurrencyDropdown />
        <button
          type="button"
          onClick={handleRefreshClick}
          aria-label="Refresh balance"
          className={`${iconRefreshCls} ${isSpinning ? iconRefreshSpinCls : ""}`}
          style={{
            background: "transparent",
            border: "none",
            padding: 0,
            cursor: "pointer",
            marginRight: "30px",
          }}
        >
          <ArrowsClockwise size={18} color="var(--color-text)" />
        </button>
      </div>
      {windowWidth > widthResponsive && (
        <button
          type="button"
          onClick={() => handleBankAccountModal()}
          className={walletIconCls}
        >
          <WalletIcon size={20} color="var(--color-text)" />
        </button>
      )}
      <UserAvatar
        firstName="Ale"
        lastName="Beta"
      />
      <NotificationMenu />
    </div>
  );
};

export default Wallet;
